const en = {
    appNav: {
        admin: {
            training: "Training",
        },
    },
    splashScreen: {
        intro: "Talk with",
        welcome: "Welcome to NTT DATA Discovery",
        scenarioSelection: "Choose the scenario"
    },
    homePage: {
        textUnderstanding: {
            header: "Text Understanding",
            description: "Get insights from input textual data through IVE NLP technologies",
            children: {
                textSummarization: {
                    header: "Text Summarization",
                    description: "" +
                        "Too many things to read? " +
                        "Summarize your documents using this module.",
                    detailedDescription: "Text summarization refers to the technique of shortening long pieces of text. The intention is to create a coherent and fluent summary having only the main points outlined in the document.\n" +
                        "Automatic text summarization is a common problem in machine learning and natural language processing (NLP).",
                },
                ner: {
                    header: "Named Entity Recognition",
                    description: "Do you know you can extract entities from textual data " +
                        "automatically using our AI power?",
                    detailedDescription: "Named-entity recognition (NER) " +
                        "(also known as entity identification, entity chunking and entity extraction)" +
                        " is a subtask of information extraction that seeks to locate and classify " +
                        "named entity mentions in unstructured text into pre-defined categories " +
                        "such as the person names, organizations, locations, medical codes," +
                        " time expressions, quantities, monetary values, percentages, etc.",
                },
                questionAnswering: {
                    header: "Question Answering",
                    description: "It is all about asking the right question. " +
                        "IVE will find the answers for you.",
                    detailedDescription: "Question answering (QA) is a computer science discipline within" +
                        " the fields of information retrieval and natural language processing (NLP)," +
                        " which is concerned with building systems that automatically answer " +
                        "questions posed by humans in a natural language.",
                },
                sentimentAnalysis: {
                    header: "Sentiment Analysis",
                    description: "Is it positive or negative? " +
                        "IVE will help you to understand.",
                    detailedDescription: "Sentiment analysis is contextual mining of text which" +
                        " identifies and extracts subjective information in source material, " +
                        "and helping a business to understand the social sentiment of their brand," +
                        " product or service while monitoring online conversations.",
                },
                languageDetection: {
                    header: "Language Detection",
                    description: "Are you not sure about the language of your users? " +
                        "You can automatically detect the text language with this module.",
                    detailedDescription:  "Are you not sure about the language of your users? " +
                        "You can automatically detect the text language with this module.",
                },

            }

        },
        textClassification: {
            header: "Text Classification",
            description: "Classify your documents using the tools in this page",
            children: {
                classifier: {
                    header: "Document Classifier",
                    description: "Classify your documents, get insights from your data.",
                    detailedDescription: "Document Classification allows you to automatically classify documents. " +
                        "In this way your documents will be organized as you wish thanks to IVE."
                },
                ontology: {
                    header: "Ontology",
                    description: "Manage document classes through ontologies",
                    detailedDescription: "Manage your classes synonyms"
                },

            }
        },
        conversation: {
            header: "Conversation",
            description: "Check out our dialogic platform integrations",
            children: {
                intentList: {
                    header: "Intent List",
                    detailedDescription: "Here you can see the intents list of the dialogic platform you chose.",
                },
                chatbotTrain: {
                    header: "Chatbot Training",
                    description: "Train your chatbot here",
                },
                chatbotTest: {
                    header: "Chatbot Testing",
                    description: "Test your chatbot here",
                },
                plugin: {
                    header: "Plugins",
                    detailedDescription: "Make you chatbot smarter. Write your plugins.",
                    description: "Make you chatbot smarter. Write your plugins.",
                },

            }
        },
        storage: {
            header: "Storage",
            description: "Store your documents in this section to get insights from them",
            children: {
                filesUpload: {
                    header: "Files Upload",
                    description: "Upload your files here",
                    detailedDescription: "Store your documents in this section to get insights from them",
                },
            }
        },
        search: {
            header: "Search",
            description: "Query your documents with the IVE NLP technologies",
            children: {
                documentSearch: {
                    header: "Document Search",
                    description: "Train your chatbot here",
                    detailedDescription: "Thanks to our NLP semantic models, with Document Search, you can" +
                        "search for documents in you storage by using: keywords, classes or Seamntic Search.",

                },
                documentSimilarity: {
                    header: "Document Similarity",
                    description: "Test your chatbot here",
                    detailedDescription: "Thanks to our NLP semantic models, given an input document, " +
                        "Document Similarity will retrieve for you the most similar documents.",
                },

            }
        },
        useCases: {
            header: "Use Cases",
            description: "Check out our use cases",
            children: {
                intelligentMailRouting: {
                    header: "Intelligent Mail Routing",
                    description: "Train your chatbot here",
                    detailedDescription: "Thanks to our text classification models, " +
                        "Intelligent Mail Routing allows you to forward the right mail to the right person."
                        ,
                },
                webRadar: {
                    header: "Web Radar",
                    description: "Test your chatbot here",
                    detailedDescription: "Thanks to our Named Entities Recognition models " +
                        "and our web information retrieval services, " +
                        "Web Radar helps you to search for entities within the web.",
                },
            }
        },
        statistics: {
            header: "Statistics",
            description: "Get IVE services statistics",
            children: {
                dialogs: {
                    header: "Dialogs Statistics",
                    description: "See Dialogs info: Most Requested Topics, Not understood questions, etc...",
                    detailedDescription: "Here you can access to the dialogic platform statistics.",
                },
                mails: {
                    header: "Mail Statistics",
                    description: "See e-mail routing info: classification results, accuracy, etc...",
                    detailedDescription: "Here you can access to the mails statistics.",
                },
            }
        },
    },

    statistics: {
        goToStatistics: "Go to statistics",
        dialogs: {
            header: "Dialogs",
            description: "See Dialogs info: Most Requested Topics, Not understood questions, etc...",
        },
        documents: {
            header: "Documents",
            description: "See Documents info: Most requested Topics, Most Requested documents, etc...",
        },
        classification: {
            header: "Classification",
            description: "See Classification info: training results, accuracy, etc...",
        },
        mail: {
            header: "Mail",
            description: "See e-mail routing info: classification results, accuracy, etc...",
        },
    },
    account: {
        title: "Account",
    },
    settings: {
        title: "Settings",
        save: "Save",
        language: {
            header: "Language",
            chooseLanguage: "Choose language",
        },
        notificationsType: {
            header: "Notifications Type",
            chooseNotificationsType: "Choose type of notifications",
        },
        dialogicPlatform: {
            header: 'Dialogic Platform',
            chooseLanguage: "Choose language",
            engine: {
                chooseEngine: "Choose Dialogic Engine"
            },
            audio: {
                enable: "Enable audio dialogic features",
                description: "Enable audio Speech-To-Text for the dialogic engine.",
                chooseLanguage: "Choose Language for SpeechToText"
            },
            advanced: {
                enable: "Enable advanced dialogic features",
                description: "Enable semantic search and other powerful features from the dialogic engine."
            },
            wikipedia: {
                enable: "Enable wikipedia search feature",
                description: "Enable wikipedia search if no answer are found."
            },
            console: {
                enable: "Enable advanced console feature",
                description: "Enable advanced console to display items"
            }
        },
        emailRouting: {
            header: "E-mails",
            enable: "Enable e-mail Routing",
            description: "Allows the classification of the e-mails for automatic routing",
        },
        webInformationRetrieval: {
            header: "Web Radar",
            enable: "Enable Web Radar",
            description: "Allow the analysis of the most relevant web sites for the automatic information retrieval",
        },
        imageCaptioning: {
            header: "Image Captioning",
            enable: "Enable Image Captioning",
            description: "Allow the analysis of images to obtain textual descriptions",
        },
    },
    globalControls: {
        notifications: {
            header: "notifications",
            noNotifications: "No notifications",
            deleteAll: "Delete all",
            content: {
                showMore: "Click to show more...",
                showLess: "Click to show less...",
            },
        },
        fileInput: {
            dragAndDrop: "Drag your file or click here to choose it from your PC!",
            selectFile: "Select a file",
            uploadFiles: "Upload Files"
        },
        fileViewer: {
            latestVersion: "Latest Version",
            lastModified: "Last modified",
            author: "Author",
            version: "Version",
        },
    },
    training: {
        ontology: {
            title: "Ontology",
            upload: {
                titlePage: "Upload your Dictionary",
                subtitle: "Upload a csv file",
                uploadMessage: "Upload ontology",
                buttonTitle: "Upload",
            },
        },
        classes: {
            title: "Classes",
            upload: {
                uploadMessage: "Upload",
                buttonTitle: "Upload",
            },
            addDocuments: "Add documents",
            reset: "Reset Training",
            selectClass: {
                chooseClass: "Choose class",
                addClass: "Add new class",
                description: "Type the name of the new class that you want to create.",
                name: "New class name",
                confirm: "Confirm",
                close: "Close"
            },
            wait: "Wait for upload please...",
            navigationDrawer: {
                deleteClass: "Delete Class",
                keywords: "Keywords",
            },
            deleteDialog: {
                title: "Delete Class",
                text: "Are you sure to delete this class?",
                yes: "Yes",
                no: "No"

            },
            chart: {
                title: "Document Classifier Training",
                description: "This charts shows the labels on which the classifier is trained. You can interact and see how the label are related to each other.",
                text: "This charts shows the labels on which the classifier is trained. You can interact and see how the label are related to each other.",
            },
        },
        conversation: {
            title: "Conversation",
            intent: "Intents",
            createIntent: {
                name: "Create intent",
                description: "Type the name of the new intent",
                label: "New intent name",
                save: "Save",
                close: "close"

            },
            userUtterances: "User Utterances",
            answers: "Answers",
            attachments: "Attachments",
            plugins: {
                header: "Plugins",
                choosePlugin: "Choose Plugin"
            },
            save: "Save",
            delete: "Delete",
            innovation: {
                uploadTitle: "Upload your startup file",
                uploadSubtitle: "Upload a xls or xlsx file",
                uploadMessage: "Upload file",
                uploadButton: "Upload file"
            }
        },
        files: {
            title: "Files Upload",
            otherResults: "Other results",
            upload: {
                titlePage: "Upload your Files",
                subtitle: "I will provide you to classify them!",
                uploadMessage: "Upload",
                buttonTitle: "Upload",
            },
            toolbar: {
                storage: "Storage",
                filter: {
                    tip: "Filter content by name",
                    label: "Filter...",
                    caseSensitive: "Case sensitive filtering",
                },
                createNew: {
                    tip: "Create new file",
                    windowTitle: "New File",
                    subToolbar: {
                        save: "save",
                    },
                },
                uploadFiles: {
                    tip: "Upload Files",
                },
                deleteAll: {
                    tip: "Delete all the files",
                },
            },
            fileResult: {
                deleteAll: "Delete all",
            },
            base: {
                deleteAllTitle: "Delete all files?",
                deleteAllDescription: "Are you sure you want to delete all the files present?",
                confirmDelete: "Delete all",
                cancelDelete: "Cancel",
                emptyMessage_1: "No files.",
                emptyMessage_2: "Click on upload button",
                emptyMessage_3_1: "to upload some files.",
                emptyMessage_3: "to upload or click on the create icon",
                emptyMessage_4: "to create a new one.",
            },
        },
        plugins: {
            templates: {
                chooseTemplate: "Choose template"
            }
        }
    },
    testing: {
        classes:{
            title: "Document Classifier Testing",
            description: "Here you can test your classifier",
            upload: {
                uploadMessage: "Classify",
                buttonTitle: "Classify",
            },
            table: {
                class: "Class",
                confidence: "Confidence",
                noData: "No data available"
            },
        },
        search: {
            title: "Search",
        },
        talk: {
            title: "Talk with me",
        },
        documentSimilarity: {
            title: "Document Similarity",
            upload: {
                titlePage: "",
                uploadMessage: "Upload",
                buttonTitle: "Check similarity",
                buttonColor: "blue",
            }
        },
        documentSearch: {
            title: "Document Search",
            upload: {
                titlePage: "Document Search",
                uploadMessage: "Upload a file",
                buttonTitle: "Check similarity",
            }
        },
    },
};

export default en;
